import {
  onActivated,
  onMounted,
} from 'vue';

export default function onComponentActivated(callback: () => (void | Promise<void>)): void {
  onMounted(callback);
  onActivated(callback);
}
